import { render, staticRenderFns } from "./WierniOjczyznie.vue?vue&type=template&id=4952cae0&scoped=true&"
import script from "./WierniOjczyznie.vue?vue&type=script&lang=js&"
export * from "./WierniOjczyznie.vue?vue&type=script&lang=js&"
import style0 from "./WierniOjczyznie.vue?vue&type=style&index=0&id=4952cae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952cae0",
  null
  
)

export default component.exports